import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Nuklir from '../views/Nuklir.vue';
import Dataset from '../views/Dataset.vue';
import DatasetDetail from '../views/DatasetDetail.vue';
import KelasIklim from '../views/KelasIklim.vue';
import BumiKini from '../views/BumiKini.vue';
import BumiKini2 from '../views/BumiKini2.vue';
import BumiKini3 from '../views/BumiKini3.vue';
import BumiKini4 from '../views/BumiKini4.vue';
import BumiKini5 from '../views/BumiKini5.vue';
import Read from '../views/Read.vue';
import Beraksi from '../views/Beraksi.vue';
import Wor from '../views/Wor.vue';
import Photos from '../views/Photos.vue';
import Postcard from '../views/Postcard.vue';
import Virtual from '../views/Virtual.vue';
import TenggelamDalamDiam from '../views/TenggelamDalamDiam.vue';
import Karya from '../views/Karya.vue';
import KabarTerkini from '../views/KabarTerkini.vue';
import SeputarIklim from '../views/SeputarIklim.vue';
import PesanKreasi from '../views/PesanKreasi.vue';
import SubmitPesanKreasi from '../views/SubmitPesanKreasi.vue';
import VideoPlayer from '../views/VideoPlayer.vue';
import ReadUserContent from '../views/ReadUserContent.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/beraksi',
    name: 'beraksi',
    component: Beraksi,
  },
  {
    path: '/bicarabumi/seputariklim/no-nukes',
    name: 'nuklir',
    component: Nuklir,
  },
  {
    path: '/beraksi/week-of-resistance',
    name: 'wor',
    component: Wor,
  },
  {
    path: '/beraksi/tenggelam-dalam-diam',
    name: 'TenggelamDalamDiam',
    component: TenggelamDalamDiam,
  },
  {
    path: '/beraksi/global-climate-strike',
    name: 'ForClimateStrike',
    component: () => import(/* webpackChunkName: "ForClimateStrike" */ '../views/ForClimateStrike.vue'),
  },
  {
    path: '/beraksi/tenggelam-dalam-diam/postcard',
    name: 'Postcard',
    component: Postcard,
  },
  {
    path: '/beraksi/tenggelam-dalam-diam/pelatihan',
    name: 'Karya',
    component: Karya,
  },
  {
    path: '/beraksi/tenggelam-dalam-diam/:uri/photos',
    name: 'Photos',
    component: Photos,
  },
  {
    path: '/beraksi/tenggelam-dalam-diam/pameran-virtual',
    name: 'Virtual',
    component: Virtual,
  },
  {
    path: '/kelas-iklim',
    name: 'kelas-iklim',
    component: KelasIklim,
  },
  // {
  //   path: '/sumber-dan-materi',
  //   name: 'sumber-dan-materi',
  //   component: BumiKini,
  // },
  {
    path: '/bumi-kini/bumi-dan-krisis-iklim',
    name: 'bumi-dan-krisi-iklim',
    component: BumiKini2,
  },
  {
    path: '/bumi-kini/faktor-faktor',
    name: 'faktor2',
    component: BumiKini3,
  },
  {
    path: '/bumi-kini/dampak-yang-mengancam',
    name: 'dampak-yang-mengancam',
    component: BumiKini4,
  },
  {
    path: '/bumi-kini/upaya-demi-upaya',
    name: 'upaya-demi-upaya',
    component: BumiKini5,
  },
  {
    path: '/bicara-bumi/kabar-terkini',
    name: 'kabar-terkini',
    component: KabarTerkini,
  },
  {
    path: '/bicara-bumi/seputar-iklim',
    name: 'seputar-iklim',
    component: SeputarIklim,
  },
  {
    path: '/bicara-bumi/pesan-dan-kreasi',
    name: 'pesan-kreasi',
    component: PesanKreasi,
  },
  {
    path: '/bicara-bumi/pesan-dan-kreasi/submit',
    name: 'submit-pesan-kreasi',
    component: SubmitPesanKreasi,
  },
  {
    path: '/bicara-bumi/pesan-dan-kreasi/video/:slug',
    name: 'video-player',
    component: VideoPlayer,
  },
  {
    path: '/bicara-bumi/pesan-dan-kreasi/article/:slug',
    name: 'read-user-content',
    component: ReadUserContent,
  },
  {
    path: '/user/change-pwd',
    name: 'changePwd',
    component: () => import(/* webpackChunkName: "changePwd" */ '../views/ChangePwd.vue'),
  },
  {
    path: '/:slug',
    name: 'bumi-kini',
    component: BumiKini,
  },
  {
    path: '/:parent/read/:slug',
    name: 'read',
    component: Read,
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound.vue'),
  },

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
